import { Link } from "react-router-dom"
import styled from "styled-components"
import { Button, OutlineButton } from "~/components/Button"
import Toast from "~/modules/toasts/Toast"
import { useTranslate } from "~/ur-react-hooks"

const Layout = styled.div`
  display: flex;
  justify-content: center;
`

const Card = styled.div`
  margin-top: 2rem;
  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};
  padding: 2rem;
  width: 392px;
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const Title = styled.h4`
  font-size: 18px;
  margin: 0;
  color: ${(props) => props.theme.colors.gray0};
`

const Description = styled.p`
  margin: 0;
  line-height: 150%;
`

export type paymentSuccessfullProps = {}

const PaymentSuccess: React.FC<paymentSuccessfullProps> = () => {
  const translations = useTranslate({
    title: "payment-success.title",
    success: "payment-success.toast",
    description: "payment-success.description",
    createWorksheet: "common.create-worksheet",
    home: "common.home",
  })

  return (
    <Layout>
      <Card>
        <Title>{translations.title}</Title>
        <Toast type="success" message={translations.success} />
        <Description>{translations.description}</Description>
        <Link to="/generator/mathematics">
          <OutlineButton leftIcon="plus" width="100%">
            {translations.createWorksheet}
          </OutlineButton>
        </Link>
        <Link to="/home">
          <Button leftIcon="home" width="100%">
            {translations.home}
          </Button>
        </Link>
      </Card>
    </Layout>
  )
}

export default PaymentSuccess
